// extracted by mini-css-extract-plugin
module.exports = {"w55u1fe":"w55u1fe","fm5tl5w":"fm5tl5w","s1kwa7md":"s1kwa7md"};